/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Headline = 'Website.Basket.PotentialLoginDiscount.Headline';
export const Explanation = 'Website.Basket.PotentialLoginDiscount.Explanation';
export const ActionText = 'Website.Basket.PotentialLoginDiscount.ActionText';
export const ContinueWithoutDiscount = 'Website.Basket.PotentialLoginDiscount.ContinueWithoutDiscount';
export const CloseWithoutDiscount = 'Website.Basket.PotentialLoginDiscount.CloseWithoutDiscount';
export const LoginButton = 'Website.Basket.PotentialLoginDiscount.LoginButton';
export const BecomeMember = 'Website.Basket.PotentialLoginDiscount.BecomeMember';
